.icon12x12 {
  width: 12px;
  height: 12px;
}

.icon16x16 {
  width: 16px;
  height: 16px;
}

.icon20x20 {
  width: 20px;
  height: 20px;
}

.icon24x24 {
  width: 24px;
  height: 24px;
}

.icon28x14 {
  width: 28px;
  height: 14px;
}

.icon32x32 {
  width: 32px;
  height: 32px;
}

.icon40x40 {
  width: 40px;
  height: 40px;
}

.icon56x56 {
  width: 56px;
  height: 56px;
}
